import { render } from "./AccountRegistrationCodeLookUp.vue?vue&type=template&id=2c99c7a3"
import script from "./AccountRegistrationCodeLookUp.vue?vue&type=script&lang=js"
export * from "./AccountRegistrationCodeLookUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__